import { render, staticRenderFns } from "./DashboardAdmin.vue?vue&type=template&id=63d9f7cb&"
import script from "./DashboardAdmin.vue?vue&type=script&lang=ts&"
export * from "./DashboardAdmin.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardAdmin.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports